export default `<svg 
    width="16" 
    height="16" 
    viewBox="0 0 16 16" 
    fill="none" 
    aria-hidden="true" 
    aria-label="circle-check"
    >
        <path d="M8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16ZM11.5312 6.53125L7.53125 10.5312C7.21875 10.8438 6.75 10.8438 6.46875 10.5312L4.46875 8.53125C4.15625 8.25 4.15625 7.78125 4.46875 7.5C4.75 7.1875 5.21875 7.1875 5.53125 7.5L7 8.96875L10.4688 5.46875C10.75 5.1875 11.2188 5.1875 11.5 5.46875C11.8125 5.78125 11.8125 6.25 11.5 6.53125H11.5312Z" fill="#21A663"/>
</svg>`;
